import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './Header.css';
import listNav from 'config/listNav';
import Breadcrumb from 'components/common/breadcrumb/Breadcrumb';

class Header extends Component {
  render() {
    const pathname = window.location.pathname;
    const { content, urlBack, titleBack } = this.props;
    return (
      <div className="c-header gradient">
        <div className="container">
          <nav>
            <Breadcrumb
              url={urlBack}
              title={titleBack}
            />

            <ul className="menu">
              {
                listNav.map((item, index) => (
                  <li key={index} className={(pathname === item.path) ? 'active' : ''}>
                    <Link to={item.path}>
                      {item.title}
                    </Link>
                  </li>
                ))
              }
            </ul>
          </nav>

          {!content || content()}
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/header/Header.jsx